<template>
    <section class="py-4 iconosImg">
            <div class="container">
                <div class="row d-flex justify-content-center py-1 py-md-5">
                    <div class="col-md-10 text-center">
                        <h2 class="textos subtitulos-intermedios azul bold">ES FÁCIL CONFIAR EN <img src="../assets/home/logoAusa.png" class="img-fluid estilo-logo-ausa" alt=""/></h2>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-1.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">ERES LO MÁS IMPORTANTE</h4>
                        <p class="textos parrafos-intermedios negro light">Nuestro <span class="textos parrafos-intermedios azul bold">enfoque en el cliente</span> nos permite aportar valor a Aseguradoras, Brokers y Empresas privadas.</p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-2.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">TECNOLOGÍA EFICIENTE</h4>
                        <p class="textos parrafos-intermedios negro light">Nuestras <span class="textos parrafos-intermedios azul bold">Apps y sistemas únicos en el sector</span> están diseñados para facilitar el uso y la experiencia de nuestros servicios.</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-3.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">SERVICIO PERSONALIZADO</h4>
                        <p class="textos parrafos-intermedios negro light"><span class="textos parrafos-intermedios azul bold">Adaptamos nuestras soluciones a las necesidades</span> de tu empresa y te asesoramos para encontrar configuración ideal.</p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-4.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">ALTA ESPECIALIDAD</h4>
                        <p class="textos parrafos-intermedios negro light">Somos <span class="textos parrafos-intermedios azul bold">profesionales experimentados</span> que se toman muy en serio el ámbito Jurídico para que tú y tus clientes no se preocupen por nada.</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center py-2">
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-5.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">UNA EXPERIENCIA REAL</h4>
                        <p class="textos parrafos-intermedios negro light">{{anoExperiencia}} años de experiencia, sólida presencia Nacional y una red con más de 500 especialistas <span class="textos parrafos-intermedios azul bold">garantizarán tu tranquilidad.</span></p>
                    </div>
                    <div class="col-md-5 text-center">
                        <img src="../assets/template/iconos/icon-6.png" alt="" class="img-fluid" />
                        <h4 class="textos parrafos-principales azulFuerte bold">SATISFACCIÓN GARANTIZADA</h4>
                        <p class="textos parrafos-intermedios negro light">Brindamos siempre un <span class="textos parrafos-intermedios azul bold">servicio oportuno y ágil</span> gracias a nuestra tecnología y Centro de Atención Permanente.</p>
                    </div>
                </div>
            </div>
        </section>
</template>
<style>
.estilo-logo-ausa {

width: 100%;
max-width: 150px!important;
}
</style>
<script>
    export default {
        data() {
            return {
                fechaActual: new Date().getFullYear(),
                anoExperiencia: "",
            };
        },
        mounted() {
            this.anoExperiencia = Math.abs(this.fechaActual - 1974);

        },
    };
</script>